import React from 'react';
import { styled, Card, LazyImage } from '@teko/ui';
import { Flex, Box } from 'reflexbox';
import { MobileLink } from '../mobile/MobileLink/MobileLink.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const mapAvatarSize = {
  sm: 26,
  md: 42,
  lg: 58
};
const SellerName = styled.div`
  font-size: 15px;
  line-height: 24px;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    color: #0d80d0;
  }
`;
const Slogan = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: #82869e;
`;
const StyledTick = styled.div`
  position: relative;
  display: inline-block;
  width: 14px;
  height: 14px;
  background-color: #52c401;
  margin-left: 4px;
  margin-top: 4px;
  border-radius: 50%;
  &:after {
    position: absolute;
    display: table;
    border: 1px solid #fff;
    border-top: 0;
    border-left: 0;
    transform: rotate(45deg) scale(1) translate(-50%, -50%);
    transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
    content: ' ';
    top: 50%;
    left: 25%;
    width: 4px;
    height: 7px;
    margin-left: 0.5px;
  }
`;
const SellerCard = (_a) => {
  var _b = _a, {
    avatar,
    name,
    slogan,
    showSlogan = true,
    showTick = true,
    avatarSize = "md",
    link,
    isAvatarHidden = false
  } = _b, props = __objRest(_b, [
    "avatar",
    "name",
    "slogan",
    "showSlogan",
    "showTick",
    "avatarSize",
    "link",
    "isAvatarHidden"
  ]);
  return /* @__PURE__ */ React.createElement(Card, __spreadValues({}, props), /* @__PURE__ */ React.createElement(Flex, null, isAvatarHidden ? null : /* @__PURE__ */ React.createElement(Box, {
    marginRight: "8px",
    width: `${mapAvatarSize[avatarSize]}px`,
    style: { borderWidth: 1 }
  }, /* @__PURE__ */ React.createElement(LazyImage, {
    height: mapAvatarSize[avatarSize],
    width: mapAvatarSize[avatarSize],
    imageWidth: 100,
    src: avatar,
    aspectRatio: 1,
    contain: true,
    borderRadius: 999,
    border: true
  })), /* @__PURE__ */ React.createElement(Flex, {
    alignItems: "flex-start",
    flexDirection: "column",
    justifyContent: "center"
  }, link ? /* @__PURE__ */ React.createElement(MobileLink, {
    href: link
  }, /* @__PURE__ */ React.createElement("a", {
    target: "_blank",
    style: { color: "unset", textDecoration: "unset" }
  }, /* @__PURE__ */ React.createElement(SellerName, null, name, " ", showTick && /* @__PURE__ */ React.createElement(StyledTick, null)))) : /* @__PURE__ */ React.createElement(SellerName, null, name, " ", showTick && !isAvatarHidden && /* @__PURE__ */ React.createElement(StyledTick, null)), slogan && showSlogan && /* @__PURE__ */ React.createElement(Slogan, null, slogan))));
};

export { SellerCard };
